import { Dialog, RaisedButton } from 'material-ui';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Col from 'reactstrap/lib/Col';
import { postLibraryRequest } from 'src/services/moduleService';
import { IHistory } from '../../interfaces';
import { LibraryModuleModel } from '../../model/LibraryModel';
import { UserModel } from '../../model/UserModel';
import { userUniqueID } from '../../utils/generalUtils';
import { CustomFlatButton } from '../reusableComponents/CutomFlatButton';
import { Loader } from '../reusableComponents/Loader/Loader';
import './libraryPage.scss';
// import { FaCertificate } from "react-icons/fa";
const certificate = require('../../images/certificate_icon.jpg');

export interface IListItemProps {
    instance?: LibraryModuleModel;
    userInstance: UserModel;
    index?: number;
    listItemProp?: string;
    onClick?: Function;
    className?: string;
    history?: IHistory;
}

interface IListItemState {
    open: boolean;
    dialogopen: boolean;
    isLoading: boolean;
    selRequestId: string;
    selRequestMId: string;
    selRequestModule: [];

}

export class ListItemImpl extends React.Component<IListItemProps, IListItemState> {
    constructor(props: IListItemProps) {
        super(props);
        this.state = { open: false, dialogopen: false, isLoading : false, selRequestId: '', selRequestMId: '',selRequestModule: []};
    }
    public handleRequest = async (uniqueId, moduleId, status) => {
        this.setState({isLoading: true})
        await postLibraryRequest(uniqueId, moduleId, status, this.props.history, this.props);
        this.setState({dialogopen: false, isLoading: false})
    }
    // public handleReject = async (uniqueId, moduleId) => {
    //     this.setState({isLoading: true})
    //     await postLibraryRequest(uniqueId, moduleId, '2', this.props.history);
    //     this.setState({dialogopen: false, isLoading: false})
    // }
    public requestModuleHandle = () => {
        if ( this.state.dialogopen === false) {
            return;
        }
        return <Dialog
            // title={`Do you really want to ${this.props.orgStatus ? 'activate' : 'deactivate'} ${this.props.instance.props.OrganizationName}'?`}
            bodyStyle={dialogBodyStyle}
            titleStyle={dialogTitleStyle}
            actionsContainerStyle={actionsContainerStyle}
            title={`Library Access.`}
            modal={false}
            className="url-modal"
            open={this.state.dialogopen}
            actions={
                [
                    <CustomFlatButton
                        label="Reject"
                        color={'white'}
                        backgroundColor={'darkred'}
                        buttonStyle={RejectButtonStyle}
                        primary={true}
                        onClick={() => this.handleRequest(this.state.selRequestId, this.state.selRequestMId, '2')}
                    />,
                    <CustomFlatButton
                        label="Approve"
                        color={'white'}
                        backgroundColor={'darkgreen'}
                        buttonStyle={RejectButtonStyle}
                        primary={true}
                        onClick={() => this.handleRequest(this.state.selRequestId, this.state.selRequestMId, '1')}
                    />
                ]
            }
            onRequestClose={() => this.setState({dialogopen: false})}
        >
            {this.state.isLoading ? <Loader type="submission"/> : ''}
            Click Approve to give access or Reject to deny access
        </Dialog>;

        // return <Dialog
        //     // bodyStyle={dialogBodyStyle}
        //     // titleStyle={dialogTitleStyle}
        //     title={'Library Modules'}
        //     modal={false}
        //     onRequestClose={() => this.setState({dialogopen: false})}
        //     open={this.state.dialogopen}
        // >
        //     <div className="user-module-details">
               
        //     </div>
        //     <div className="library-module" >
        //     <RaisedButton
        //             type="submit"
        //             // style={{
        //             //     backgroundColor: TextColor,
        //             // }}
        //             // onClick= {() => this.submitSelectedLibrary(this.state.selLibraryModules)}
        //             className="submit-button submit-raised-btn  btn-placement"
        //             label="Submit"
        //             primary={true}
        //         />
        //         <RaisedButton
        //             type="submit"
        //             // style={{
        //             //     backgroundColor: TextColor,
        //             // }}
        //             onClick= {() => this.setState({dialogopen: false})}
        //             className="cancel-button cancel-raised-btn  btn-placement"
        //             label="Cancel"
        //         />
        //         </div>
        //         {this.state.isLoading ? <Loader type="submission"/> : ''}
        // </Dialog>;
    }
    public render() {
        const { instance, userInstance, history, index } = this.props;
        const isAdmin = UserModel.isAdmin(userInstance);
        
        return <div className="list-item" >
            {this.requestModuleHandle()}
            <Col className="serial-no center" sm={1} >{index}</Col>
            {/* {isAdmin ? <Col className="name" sm={2} >{instance.props.userName}</Col> : ''} */}
            {/* {isAdmin ? <Col className="modulename" sm={4} >{instance.props.moduleName}</Col> : ''} */}
            <Col className="modulename" sm={3} >{instance.props.moduleName ? instance.props.moduleName : ''}</Col>
            {/* {isAdmin ? '' : <Col className="space" sm={2} >{instance.props.dateCreated}</Col>} */}
            <Col className="category" sm={2} >{instance.props.category}</Col>
            <Col className="date organization" sm={2} >{instance.props.organizationName}</Col>

            <Col className="date req_date" sm={2} >{instance.props.requestDate}</Col>
            {/* <Col className="status" sm={2} >{instance.props.status == "0" ? "Requested" : instance.props.status == "1" ? "Accepted" : "Rejected"}</Col> */}
            {/* <Col className={instance.props.status} onClick= {() => this.setState({dialogopen: true,selRequestMId: instance.props.moduleId, selRequestId: instance.props.uniqueId})} sm={2} >{instance.props.status}</Col> */}
            {instance.props.status === "Approved" ?
                <Col className={instance.props.status + ' '+ 'lib_status'} sm={2} >{instance.props.status}</Col>
            : 
                // <Col className={instance.props.status} onClick= {() => this.setState({dialogopen: true,selRequestMId: instance.props.moduleId, selRequestId: instance.props.requestId})} sm={2} >{instance.props.status}</Col>
                <Col className={instance.props.status + ' '+ 'lib_status'} onClick= {() => this.setState({dialogopen: true,selRequestMId: instance.props.moduleId, selRequestId: instance.props.requestId})} sm={2} >{instance.props.status}</Col>
            }
        </div >;
    }
}

export function mapStateToProps(state) {
    return {
        userInstance: UserModel.get(userUniqueID(state))
    };
}
const dialogBodyStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    color: 'white',
    // width: '80%'
};

const actionsContainerStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    // width: '80%'
};
const RejectButtonStyle: React.CSSProperties = {
    margin: '10px',
};
const dialogTitleStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    color: '#fdfcfc',
    // width: '80%'
};
export const ListItem = withRouter(connect<{}, {}, IListItemProps>(mapStateToProps)(ListItemImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LibraryRequest/ListItem.tsx